
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 56 56","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.343 9.657c1.98-1.98 2.97-2.97 4.112-3.341a5 5 0 013.09 0c1.142.37 2.132 1.36 4.112 3.34l12.686 12.687c1.98 1.98 2.97 2.97 3.341 4.112a5 5 0 010 3.09c-.37 1.142-1.36 2.132-3.34 4.112L33.656 46.343c-1.98 1.98-2.97 2.97-4.112 3.341a5 5 0 01-3.09 0c-1.142-.37-2.132-1.36-4.112-3.34L9.657 33.656c-1.98-1.98-2.97-2.97-3.341-4.112a5 5 0 010-3.09c.37-1.142 1.36-2.132 3.34-4.112L22.344 9.657z"}})])
          )
        }
      }
    